import { IsNumber } from 'class-validator';

export class UpdateAllFireResponseDto {
  @IsNumber()
  totalProcessed: number;

  @IsNumber()
  successfulUpdates: number;

  @IsNumber()
  failedUpdates: number;
}
